import { Component, inject } from "@angular/core";
import { QeleoIconComponent } from "../qeleo-icon/qeleo-icon.component";
import { ContactFormComponent } from "../../modals/contact-form/contact-form.component";
import { CommonModule, ViewportScroller } from "@angular/common";
import { ModalService } from "../../../core/services/modal.service";

@Component({
  selector: "app-contact-us",
  standalone: true,
  imports: [QeleoIconComponent, CommonModule],
  templateUrl: "./contact-us.component.html",
  styleUrl: "./contact-us.component.scss",
})
export class ContactUsComponent {
    private modalService = inject(ModalService);

    openContactModal() {
        this.modalService.show(ContactFormComponent, {}, "lg", true, 'contact-modal');
    }
}
